import { createElement, FC, useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { NotFoundContainer } from "./NotFoundContainer";
import {
  RedirectSsoLoginPage,
  RedirectSsoLoginPageProps,
} from "../components/RedirectSsoLoginPage/RedirectSsoLoginPage";
import { usePortalAuth } from "../providers/keycloak-provider";
import { useKeycloak } from "@react-keycloak/ssr";
import { useMediaQuery } from "@mui/material";

export const RedirectSsoLoginPageContainer: FC = () => {
  const { initialized } = useKeycloak();
  const { accessToken } = usePortalAuth();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const redirectPath = searchParams.get("redirect_path");
  const isSmallScreen = useMediaQuery("(max-width: 576px)");

  const [isWaiting, setIsWaiting] = useState(true);

  useEffect(() => {
    if (accessToken && initialized) {
      window.location.href = `${window.location.origin}${redirectPath}`;
    }

    if (!accessToken && initialized) {
      setTimeout(() => {
        setIsWaiting(false);
      }, 1000); // Avoid Firefox side effects
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, initialized]);

  const redirect = useCallback(() => {
    window.location.href =
      `${window.location.origin}/login/redirect-sso-page?redirect_path=` +
      encodeURIComponent(redirectPath ?? "");
  }, [redirectPath]);

  if (!redirectPath) {
    return <NotFoundContainer />;
  }

  const props: RedirectSsoLoginPageProps = {
    isWaiting,
    redirect,
    isSmallScreen,
  };

  return createElement(RedirectSsoLoginPage, props);
};
